export const LISTING_PUBLICATIONS_POLL_INTERVAL = 3000
